/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/7/2021
 * @Example
 */

import Api from '../../../services/api';
import { cancel, take, takeLatest } from "redux-saga/effects";
import { types } from "./W06F0010_actions";
import { delay } from "redux-saga";

export default function W06F0010Sagas() {
    return [
        watchLoadForm(),
    ];
}
export function* loadForm(data) {
    try {
        yield delay(300);
        const response = yield Api.put('/w06f0010/get-form', data.params);
        if (response && response.data) {
            data.cb && data.cb(null, response.data);
        }
        else {
            data.cb && data.cb(response, null);
        }
    } catch (e) {
        console.log('loadForm view')
    }
}

export function* watchLoadForm() {
    while (true) {
        const watcher = yield takeLatest(types.W06F0010_LOAD_FORM, loadForm);
        yield take(['LOGOUT', 'NETWORK']);
        yield cancel(watcher);
    }

}
